import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap } from '@angular/router';
import { EncrDecrService } from 'src/app/AuthGuard/EncrDecrService';
import { MasterService } from '../../Shared/app.Masters.Service';
import { constantUrl } from "../../Shared/constantUrl";
import { LmsService } from '../services/lms.service';

declare var $: any;

@Component({
    selector: 'app-loan-application-form',
    templateUrl: './loan-application-form.component.html',
    styleUrls: ['./loan-application-form.component.scss'],
    standalone: false
})
export class LoanApplicationFormComponent implements OnInit, OnDestroy {
  @Input() loanId: any;
  @Input() index?: any;

  resData: any;
  currentUser: any;
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  loading = false;
  isLoaded = false;
  customerProfileBaseUrl: any = constantUrl.customerProfilePicUrl;

  data: any = {};
  primaryApplicant: any = null;
  coApplicants: any[] = [];
  guarantors: any[] = [];
  today = new Date();
  showSpinner = false;
  systemconfig: any = {};
  private modalId: string = '';

  constructor(
    private lmsService: LmsService,
    private router: ActivatedRoute,
    private _EncrDecrService: EncrDecrService,
    private cdRef: ChangeDetectorRef,
    private _MasterService: MasterService,
    private _snackBar: MatSnackBar
  ) {
    this.router.paramMap.subscribe((param: ParamMap) => {
      if (this.loanId == null) {
        this.loanId = Number(
          this._EncrDecrService.decrypt(decodeURIComponent(param.get('id')!))
        );
      }
    });
  }

  ngOnInit() {
    console.log(this.loanId);
    this.CompanyDetails();
    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
    this.modalId = `#LoanAppForm${this.index !== undefined && this.index !== null ? this.index : 'default'
      }`;
  }

  ngOnDestroy(): void {
    if (this.modalId) {
      $(this.modalId).off('hidden.bs.modal');
    }
  }
  CompanyDetails() {
    this.showSpinner = true;

  }
  // Add this method in your component class
  maskDocumentNumber(docNumber: string, docName: string): string {
    if (!docNumber || docNumber.length < 4) {
      return docNumber || 'N/A';
    }

    const docType = (docName || '').toLowerCase();

    // Different masking logic based on document type
    if (docType.includes('aadhar') || docType.includes('aadhaar')) {
      // Aadhaar: XXXX XXXX 1234 → XXXX XXXX XXXX (last 4 visible)
      return docNumber.replace(/(\d{4})(\d{4})(\d{4})/, 'XXXX XXXX $3');
    }
    else if (docType.includes('pan')) {
      // PAN: ABCDE1234F → ABCDE****F
      return docNumber.replace(/(.{5})(.{4})(.{1})/, '$1****$3');
    }
    else if (docType.includes('passport')) {
      // Passport: Usually show first 2 and last 2
      return docNumber.replace(/(.{2})(.+)(.{2})/, '$1****$3');
    }
    else if (docType.includes('voter') || docType.includes('driving') || docType.includes('dl')) {
      // Voter ID / Driving License: Show last 4 digits
      return 'XXXX XXXX ' + docNumber.slice(-4);
    }
    else {
      // Default masking: Show first 2 and last 4 characters
      const first = docNumber.substring(0, 2);
      const last = docNumber.substring(docNumber.length - 4);
      const middle = '*'.repeat(docNumber.length - 6);
      return first + middle + last;
    }
  }

  // ── Called from parent via <ng-content> click ──────────
  showLoanApplicationForm() {
    if (this.isLoaded) {
      $(this.modalId).modal('show');
      return;
    }

    this.isLoaded = true;
    this.loading = true;

    // Reset state when modal is closed
    $(this.modalId).off('hidden.bs.modal');
    $(this.modalId).on('hidden.bs.modal', () => {
      this.isLoaded = false;
      this.resData = null;
      this.data = {};
      this.primaryApplicant = null;
      this.coApplicants = [];
      this.guarantors = [];
      this.cdRef.detectChanges();
      $(this.modalId).off('hidden.bs.modal');
    });

    $(this.modalId).modal('show');
    $(this.modalId).css('z-index', '1050');
    this._MasterService
      .GetConfigurationDetails()
      .subscribe((result) => {
        this.systemconfig = JSON.parse(JSON.stringify(result))[0];

        this.showSpinner = false;
      });

    this.lmsService.LMS_Get_Loan_Card_Info({ LoanId: this.loanId }).subscribe({
      next: (res: any) => {
        this.processData(res);
        this.loading = false;
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error loading Loan Application Form:', err);
        this.isLoaded = false;
        this.loading = false;
        this.cdRef.detectChanges();
      },
    });
  }

  // ── Data Processing ────────────────────────────────────
  processData(response: any) {
    const customers: any[] = response?.Item2 || [];

    const customerMap = new Map<number, any>();
    customers.forEach((cust: any) => {
      const id = cust.CustomerId;
      customerMap.set(id, {
        info: cust,
        kyc: (response?.Item9 || []).filter((k: any) => k.KYC_CustomerId === id),
        references: (response?.Item6 || []).filter((r: any) => r.CR_CustomerId === id),
        fi: (response?.Item10 || []).filter((f: any) => f.CustomerId === id),
        tvr: (response?.Item11 || []).filter((t: any) => t.TVR_CusrtomerId === id),
        income: (response?.Item19 || []).filter(
          (i: any) => i.CustomerId === id && i.Type === 'Income'
        ),
        expense: (response?.Item19 || []).filter(
          (i: any) => i.CustomerId === id && i.Type === 'Expense'
        ),
      });
    });

    const sorted = [...customers].sort((a: any, b: any) => {
      const order: any = { H: 1, C: 2, G: 3 };
      return (order[a.AC_CustomerType] || 99) - (order[b.AC_CustomerType] || 99);
    });

    this.primaryApplicant = sorted.find((c: any) => c.AC_CustomerType === 'H') || null;
    this.coApplicants = sorted.filter((c: any) => c.AC_CustomerType === 'C');
    this.guarantors = sorted.filter((c: any) => c.AC_CustomerType === 'G');

    const loanInfo = response?.Item1?.[0] || {};
    const approvedTerms =
      (response?.Item16 || []).find((i: any) => i.Type === 'Approved') || {};

    this.data = {
      loan: loanInfo,
      approvedTerms,
      asset: response?.Item7?.[0] || null,
      applicationNo: loanInfo.Application_No || '',
      customerMap,
      bankDetails: response?.Item13 || [],
      references: response?.Item6 || [],
      incomeExpense: response?.Item19 || [],
      cibilData: response?.Item3 || [],
    };

    this.resData = response;
  }

  // ── Template Helpers ───────────────────────────────────

  getTotalIncome(custId: number): number {
    const custData = this.data?.customerMap?.get(custId);
    return (custData?.income || []).reduce(
      (sum: number, i: any) => sum + parseFloat(i.Amount || 0),
      0
    );
  }

  getTotalExpense(custId: number): number {
    const custData = this.data?.customerMap?.get(custId);
    return (custData?.expense || []).reduce(
      (sum: number, e: any) => sum + parseFloat(e.Amount || 0),
      0
    );
  }

  getCibilScore(custId: number): string {
    const c = (this.data?.cibilData || []).find(
      (x: any) => x.CRC_CustomerId === custId
    );
    return c?.CRC_CreditVisionScore || 'N/A';
  }

  getCibilRec(custId: number): string {
    const c = (this.data?.cibilData || []).find(
      (x: any) => x.CRC_CustomerId === custId
    );
    return c?.CRC_Recommendation || 'N/A';
  }

  getDisbursmentBank(): any {
    return (
      (this.data?.bankDetails || []).find((b: any) => b.PdcType === 'Disbursment') || null
    );
  }

  getCustomerKyc(custId: number): any[] {
    return this.data?.customerMap?.get(custId)?.kyc || [];
  }

  getGlobalReferences(): any[] {
    return this.data?.references || [];
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
  }

  OnClose() {
    $(this.modalId).modal('hide');
  }

  print() {
    // Print only the modal body content
    const printContent = document.getElementById('loanAppPrintSection');
    if (!printContent) return;
    const originalBody = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalBody;
    window.location.reload();
  }
}